import axios from 'axios';
// import {API} from '../utils/APIUtils';

// jobs crud start
export const getPersonalityTestResultAPIHelper = async () => {
  try {
     const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
    const response = await axios.get(`/api/v1/users/personality`,{
            headers: {
                Authorization: setAuthHeader(token), // Correct function call
                // "x-api-key": apiKey,
                "Content-Type": "application/json",
            }
        });
    console.log("Numerology GET response---",response);
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};

export const getPersonalitySaboteurAPIHelper = async () => {
  try {
    const token = localStorage.getItem("objectId"); // Ensure this is storing a valid token
        const apiKey = process.env.REACT_APP_API_KEY;

        const setAuthHeader = (token) => {
            return token ? `Bearer ${token}` : null;
        };
    const response = await axios.get(`/api/v1/users/saboteur`,{
      headers:{
        Authorization: setAuthHeader(token),
        "Content-Type":"application/json",
      }
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response?.data || error.message);
  }
};
